/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-bootstrap';

import CategoryLabel from 'components/categoryLabel';
import ReactMarkdown from 'react-markdown';
import CountDown from 'components/participates/countDown';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import SideBarNotify from './SideBarNotify';
import SideBarOffer from './SideBarOffer';
import ItemPeopleOffer from './ItemPeopleOffer';

const Detail = ({ detail }) => {
  const { category, title, smallDescription,
    imageDetail, imageMob, description, shouldKnow, includes, offers,
    status, closeDate, serverDate, startDate } = detail;

  const { auctionId, allOffers } = useSelector((state) => state.offersSocket.offersSock);

  const { id } = useParams();
  const [dataSocket, setDataSocket] = useState(false);

  const validateSocketData = () => {
    let data = false;
    if (auctionId.toString() === id.toString()) {
      data = true;
    }
    return setDataSocket(data);
  };

  useEffect(() => {
    if (auctionId !== undefined) {
      validateSocketData();
    }
  }, [auctionId]);

  return (
    <>
      <Row>
        <Col className="d-none d-sm-block">
          <h2 className="mt-60 text-tangaroa">{title}</h2>
          <p className="my-15 text-tangaroa">{smallDescription}</p>
        </Col>
      </Row>
      <Row className="d-flex flex-column-reverse flex-sm-row">
        <Col lg={9}>
          <div className="title-mobile d-block d-sm-none">
            <h2 className={`text-tangaroa ${status}`}>{title}</h2>
            <p className="my-15">{smallDescription}</p>
          </div>

          <div className={(status === 'CLOSED_WITH_WINNERS' || status === 'CLOSED') && 'd-none text-tangaroa'}>
            <div className="mb-30 d-block d-sm-none text-tangaroa">
              {status === 'PUBLISHED' ? 'Finaliza en:' : 'Inicia en:' }
              <CountDown
                closeDate={status === 'PUBLISHED' ? closeDate : startDate}
                todayDate={serverDate} />
            </div>
          </div>

          <div className="carousel-img">
            <img
              src={imageDetail}
              alt="item"
              className="w-100 d-none d-sm-block" />
            <img
              src={imageMob}
              alt="item"
              className="w-100 d-block d-sm-none" />
            <CategoryLabel
              page="auctions"
              category={category} />
          </div>
          <p className="mt-30 text-tangaroa">
            <ReactMarkdown>{description}</ReactMarkdown>
          </p>
          <h3 className="text-tangaroa f-600">¿Qué incluye?</h3>

          <div className="markdown-menu">
            <div className="markdown-item text-tangaroa">
              <ReactMarkdown>{includes}</ReactMarkdown>
            </div>
          </div>

          <hr className="my-30" />
          <h2 className="mb-30 text-tangaroa f-600">Lo que debes saber</h2>
          <p className="mb-60 text-tangaroa">
            <ReactMarkdown>{shouldKnow}</ReactMarkdown>
          </p>

          <div className={`d-sm-none pb-60 ${status === 'COMING_SOON' ? 'd-none' : 'd-block'}`}>
            <hr className="pl-2 pr-2" />
            <div className={offers.length > 8 ? 'max-offer' : ''}>
              {status === 'PUBLISHED' ? (<h3 className="text-left mt-30 text-horizon">Últimas ofertas</h3>) : (<h3 className="text-left mt-30">Ofertas realizadas</h3>)}

              {dataSocket ? (
                allOffers.map((o) => (
                  <ItemPeopleOffer
                    offer={o.offer}
                    person={o.personName}
                    type="Open" />
                ))
              ) : (
                offers.map((o) => (
                  <div key={o.offer}>
                    <ItemPeopleOffer
                      offer={o.offer}
                      person={o.personName}
                      type={status === 'PUBLISHED' ? 'Open' : 'Closed'} />
                  </div>
                ))
              )}
            </div>
          </div>

        </Col>

        <Col lg={3} sm={12}>
          <SideBarNotify />
          <SideBarOffer />
        </Col>
      </Row>
    </>
  );
};

Detail.propTypes = {
  detail: PropTypes.shape({
    category: PropTypes.shape({
      title: PropTypes.string.isRequired,
      color: PropTypes.string.isRequired,
      iconUrl: PropTypes.string.isRequired,
    }).isRequired,
    title: PropTypes.string.isRequired,
    smallDescription: PropTypes.string.isRequired,
    imageHome: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    shouldKnow: PropTypes.string.isRequired,
    status: PropTypes.string.isRequired,
    offers: PropTypes.arrayOf(PropTypes.shape({
      offerWinner: PropTypes.bool.isRequired,
      offer: PropTypes.number.isRequired,
      personName: PropTypes.string.isRequired,
      offerDate: PropTypes.string.isRequired,
    })).isRequired,
  }).isRequired,
};

export default Detail;
